import React from 'react';
import {
  Menu,
} from 'antd';


const HeaderNavBar = () => (
  <header className="app-header ant-menu ant-menu-horizontal  ant-menu-light ant-menu-root">
    <div>性能测试</div>
  </header>
);

export default HeaderNavBar;



// WEBPACK FOOTER //
// ./app/scripts/components/header.jsx